import throttle from 'lodash/throttle';
import Markdown from 'markdown-to-jsx';
import { useCallback, useState } from 'react';
import { QnA } from '@bridebook/toolbox/src/seo-facets/get-seo-data';
import renderers from '../location-description/markdown-renderers';
import { ChevronDownSpriteIcon } from '../search-svg-sprite';
import FAQMDListItem from './faq-md-list-item';

const mdOptions = {
  overrides: {
    li: FAQMDListItem,
    a: renderers(() => false).overrides.a,
  },
};

interface IProps {
  faq: QnA;
  startOpen: boolean;
}

const FAQItem = ({ faq, startOpen }: IProps) => {
  const [isOpen, setIsOpen] = useState(startOpen);

  const onToggle = useCallback(
    // Without throttle this can enter in a loop on HMR
    throttle(() => {
      setIsOpen((isOpen) => !isOpen);
    }, 100),
    [],
  );

  return (
    <details onToggle={onToggle} open={isOpen}>
      <summary className="bsfq-summary">
        <h3 className="bsfq-q">{faq.question}</h3>
        <span className="bsfq-arrow-wrap">
          <span className="bsfq-arrow">
            <ChevronDownSpriteIcon width={14} height={8} />
          </span>
        </span>
      </summary>
      <div className="bsfq-answer">
        <Markdown options={mdOptions}>{faq.answer}</Markdown>
      </div>
    </details>
  );
};

export default FAQItem;
